import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertMessageComponent, ButtonComponent, IconComponent } from '@shared/components/ui';
import { DefaultImageDirective } from '@shared/directives';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TranslateModule } from '@ngx-translate/core';
import { isMobileView } from '@core/utils';
import { FaqsComposition } from '@shared/compositions';
import { DialogRef } from '@ngneat/dialog';
import { untilDestroyed } from '@ngneat/until-destroy';
import { FaqFormComponent } from '@shared/components/forms';

@Component({
  selector: 'app-faq-details',
  imports: [CommonModule, AlertMessageComponent, DefaultImageDirective, IconComponent, NgxSkeletonLoaderModule, TranslateModule, ButtonComponent],
  templateUrl: './faq-details.component.html',
  styleUrl: './faq-details.component.scss',
})
export class FaqDetailsComponent extends FaqsComposition implements OnInit {
  protected isMobileView = isMobileView();
  private readonly _dialogRef: DialogRef;

  constructor() {
    super();
    this.isLoading = true;
    if (!this.isMobileView) {
      this._dialogRef = inject(DialogRef);
    }
  }

  ngOnInit() {
    const faqId = this.isMobileView ? this._bottomSheetService.currentSheetData.faqId : this._dialogRef.data.faqId;

    if (faqId) {
      this._fetchFaqById(faqId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (faq) => {
            this.currentFaq = faq;
          },
          error: (error) => {
            console.error(error);
            this.isLoading = false;
            if (this.isMobileView) {
              this._bottomSheetService.close();
            } else {
              this._dialogRef?.close();
            }
          },
        });
    }
  }

  close() {
    if (this.isMobileView) {
      this._bottomSheetService.close();
    } else {
      this._dialogRef.close();
    }
  }

  openEditFaqDialog() {
    this._dialogService.open(FaqFormComponent, {
      size: 'md',
      closeButton: false,
      windowClass: 'dialog-overflow-y-auto',
      data: {
        faq: this.currentFaq,
      },
    });
  }

  openEditFaqSheet() {
    this._bottomSheetService.open(FaqFormComponent, {
      height: '95%',
      showCloseButton: false,
      data: {
        faq: this.currentFaq,
      },
    });
  }
}
